import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectsSelectListModule } from '@portal-core/projects/components/projects-select-list/projects-select-list.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { AutocompleteInputModule } from '@portal-core/ui/autocomplete/components/autocomplete-input/autocomplete-input.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';
import { FilterPickerComponent } from './filter-picker.component';

@NgModule({
  declarations: [FilterPickerComponent],
  imports: [
    AutocompleteInputModule,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    McColorModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    ProjectAvatarModule,
    ProjectsSelectListModule,
    ReactiveFormsModule,
    ProjectAsyncModule
  ],
  exports: [FilterPickerComponent]
})
export class FilterPickerModule { }
